import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AgePipe } from './age.pipe';

@Component({
  selector: 'daas-consulting-shared-age',
  standalone: true,
  templateUrl: './age.component.html',
  styleUrl: './age.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AgePipe, CommonModule],
})
export class AgeComponent {
  @Input() dateOfBirth: Date | null = null;
  @Input() showParenthesis = true;
}
